import Vue from 'vue'
import Router from 'vue-router';
import products from '../components/products';

Vue.use(Router)

export default new Router({
  // mode : 'history',
  routes: [
    {
      path: '/products',
      name: 'products',
      component: products
    },
  ]
})



// WEBPACK FOOTER //
// ./src/components/products/router/index.js